module.exports = __webpack_public_path__ + "static/media/heart_arrow.f876cb18.svg";